import React from 'react';
import { useSelector } from 'react-redux';
import Icon from '../../ui/icons/Icon';
import iconsList from '../../ui/icons/iconsList';
import classes from './AccessibilityStatement.module.css';

const AccessibilityStatement = () => {

    const { lang, texts } = useSelector(state => state.translate);

    return (
        <a aria-label={texts.accessibilityStatement} target="_blank" href={`https://www.gov.il/${lang}/pages/accessibility_edu`}>
            <Icon size='34px' className={classes.AccessibilityStatementIcon} name={iconsList.settings} tooltip={texts.accessibilityStatement} />
        </a>
    );
}

export default AccessibilityStatement;